import { useEffect } from "react";
import { Link } from "react-router-dom";
import servicesData from "../../data/servicesData";

export default function ServicePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* BREADCRUMBS */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Services</li>
          </ol>
          <h2>Our Services</h2>
        </div>
      </section>

      {/* ALL SERVICES */}
      <section id="services" className="services">
        <div className="container">

          <header className="section-header">
            <h2>What We Offer</h2>
            <p>
              Comprehensive digital services to transform your business and
              accelerate growth in the digital era.
            </p>
          </header>

          <div className="row gy-4">
            {servicesData.map((service, index) => (
              <div
                className="col-lg-4 col-md-6"
                key={service.id}
                data-aos="fade-up"
                data-aos-delay={200 + index * 100}
              >
                <div className={`service-box ${service.color}`}>
                  <i className={`${service.icon} icon`} />
                  <h3>{service.title}</h3>
                  <p>{service.shortDesc}</p>
                  <Link to={`/services/${service.slug}`} className="read-more">
                    <span>Read More</span>
                    <i className="bi bi-arrow-right" />
                  </Link>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}